import { channelsInstance } from '@/api/instances'

const createVideoCall = async ({ dispatch }, { channelId }) => {
  try {
    const { meeting, attendee, videoCall } = await channelsInstance.post(
      `channels/${channelId}/video_call/meetings`
    )

    return {
      meeting,
      videoCall,
      attendee
    }
  } catch (error) {
    dispatch(
      'errors/setError',
      {
        error: `Ops, erro ao criar a video chamada. Feche a aba e tente novamente.`,
        request: 'chime/createVideoCall'
      },
      { root: true }
    )
    return null
  }
}

const endVideoCall = async (store, { channelId, videoCallId }) => {
  try {
    await channelsInstance.post(
      `channels/${channelId}/video_call/meetings/${videoCallId}/end`
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'channel/endVideoCall' },
      { root: true }
    )
  }
}

export default { createVideoCall, endVideoCall }
